import { AppleProfilePresetType } from '@era/stores';

/**
 * Type guard to validate that a value is a valid AppleProfilePresetType.
 * This avoids the need for type casting when reading from route data.
 */
export function isValidProfileType(value: unknown): value is AppleProfilePresetType {
  return (
    typeof value === 'string' &&
    (value === 'airplay-security' || value === 'restrictions-profile' || value === 'wifi-profile')
  );
}

/**
 * Mapping from profile type to its header label.
 * This makes it easy to add new profile types without modifying if/else chains.
 */
export const PROFILE_TYPE_HEADER_LABELS: Record<AppleProfilePresetType, string> = {
  'airplay-security': 'Name',
  'restrictions-profile': 'ID',
  'wifi-profile': 'SSID',
};

/**
 * Get the header label for a given profile type.
 * Returns a default value if the profile type is not found.
 */
export function getHeaderLabelForProfileType(profileType: AppleProfilePresetType): string {
  return PROFILE_TYPE_HEADER_LABELS[profileType] ?? 'Name';
}
